import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";

export const FeriasCivilService = {
  async getFerias(filter) {
    const response = await BaseService.fetchResponseFromAPIPost(`civil/ferias/pesquisar`, filter);
    if (response.error) {
      SnackBarModule(response.message, "error");
    }
    return response.message;
  },

  async getLotacaoByUnidade(unidade) {
    const response = await BaseService.fetchResponseFromAPIGet(`lotacao-by-unidade/${unidade}`);
    if (response.error) {
      SnackBarModule("Houve um erro ao listar as unidades por unidade", "error");
    }
    return response.content;
  },

  async getFeriasProrrogadas() {
    const response = await BaseService.fetchResponseFromAPIGet(`civil/ferias/prorrogadas-interrompida`);
    if (response.error) {
      SnackBarModule("Houve um erro ao consultar as informações deste item", "error");
    }
    return response.content;
  },
  async test() {
    return await BaseService.fetchResponseFromAPIGet(`inf`);
  },
  async getFeriasNaoSolicitada(filter) {
    const response = await BaseService.fetchResponseFromAPIPost(`civil/ferias/nao-solicitadas`, filter);
    if (response.error) {
      SnackBarModule(response.message, "error");
    }
    return response.message;
  },
  async getFeriasParaVencer(filter) {
    const response = await BaseService.fetchResponseFromAPIPost(`civil/ferias/para-vencer`, filter);
    if (response.error) {
      SnackBarModule(response.message, "error");
    }
    return response.message;
  },

  async getFeriasById(id) {
    const response = await BaseService.fetchResponseFromAPIGet(`civil/ferias/${id}`);
    if (response.error) {
      SnackBarModule("Houve um erro ao consultar as informações deste item", "error");
    }
    return response.content;
  },

  async getExerciciosPesquisar(){
    const response = await BaseService.fetchResponseFromAPIGet("civil/ferias/exercicioferias");
    if (response.error) {
      SnackBarModule("Houve um erro ao listar as exercícios", "error");
    }
    return response.content;
  },

  async getExerciciosFeriasPremio(){
    const response = await BaseService.fetchResponseFromAPIGet("civil/ferias/premio/exercicio");
    if (response.error) {
      SnackBarModule("Houve um erro ao listar os exercícios", "error");
    }
    return response.content;
  },

  async getGraduacao() {
    const response = await BaseService.fetchResponseFromAPIGet("graduacao");
    if (response.error) {
      SnackBarModule("Houve um erro ao listar as graduações", "error");
    }
    return response.content;
  },

  async getUnidade() {
    const response = await BaseService.fetchResponseFromAPIGet("unidade");
    if (response.error) {
      SnackBarModule("Houve um erro ao listar as unidades", "error");
    }
    return response.content;
  },

  async getExercicio() {
    const response = await BaseService.fetchResponseFromAPIGet("civil/ferias/exercicio");
    if (response.error) {
      SnackBarModule("Houve um erro ao listar os exercícios", "error");
    }
    return response.content;
  },
  async getStatus() {
    const response = await BaseService.fetchResponseFromAPIGet("civil/ferias/status");
    if (response.error) {
      SnackBarModule("Houve um erro ao listar os status", "error");
    }
    return response.content;
  },
  async getValidacaoSolicitacao() {
    const response = await BaseService.fetchResponseFromAPIGet("civil/ferias/validasolicitacao");
    if (response.error) {
      SnackBarModule("Houve um erro ao verificar permissão", "error");
    }

    return response.content;
  },

  async getMilitaresFeriasAgendada(postData) {
    const response = await BaseService.fetchResponseFromAPIPost("civil/ferias/militares-agendado", postData);
    if (response.error) {
      SnackBarModule("Houve um erro ao verificar permissão", "error");
    }
    return response.message;
  },

  async getCivilResponsavel() {
    const response = await BaseService.fetchResponseFromAPIGet("civil/listagerentes");
    if (response.error) {
      SnackBarModule("Houve um erro ao verificar permissão", "error");
    }
    return response.content;
  },
  
  async getExercicioPorMilitar(idSigrh) {
    const response = await BaseService.fetchResponseFromAPIGet(`civil/ferias/exercicio/${idSigrh}`);
    if (response.error) {
      SnackBarModule("Houve um erro ao listar os exercícios", "error");
    }
    return response.content;
  },

  async getExercicioEmFeriasCadaMilitar(idSigrh) {
    const response = await BaseService.fetchResponseFromAPIGet(`civil/ferias/exercicioferias/${idSigrh}`);
    if (response.error) {
      SnackBarModule("Houve um erro ao listar os exercícios", "error");
    }
    return response.content;
  },

  async verificarFeriasCassadas(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(`civil/ferias/verificar-cassadas`, postData);
    if (response.error) {
      SnackBarModule("Houve um erro ao verificar férias cassadas", "error");
    }
    return response.message;
  },
}